import { Box, styled } from '@mui/material';
import { pxToRem } from '@themes';
var NotFoundContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    maxWidth: '100vw',
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.white,
    padding: pxToRem(40),
    border: "".concat(pxToRem(1), " solid ").concat(theme.colors.athensGray),
    borderRadius: pxToRem(16)
  };
  return styles;
});
export { NotFoundContainer };